import { CHANGE_LANGUAGE } from 'redux/actions/types';

// thunk logic: https://redux.js.org/usage/writing-logic-thunks

export const changeLanguageAction = (language) => (dispatch) => {
    return new Promise(async (resolve, reject) => {
        try {
            dispatch({ type: CHANGE_LANGUAGE, payload: { language } });
            resolve(true);
        } catch (err) {
            reject(err);
        }
    });
};
